import UserAppContext from '../../hook/UserAppContext';
import './banner.css';

const Banner = () => {

      const {user, dataApp} = UserAppContext()
      const {banners} = user.user

      return (
            <div className="jd_theme__banner">
                  <div className="jd_banner__content">
                       <img src={banners.data ? dataApp.banner.image : banners[0].image} alt={banners.data ? dataApp.banner.title : banners[0].title} /> 
                  </div>   
            </div>
      )
}

export default Banner;